"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const fetch_retry_1 = __importDefault(require("fetch-retry"));
const Log = __importStar(require("./Log"));
const fetchRetry = (0, fetch_retry_1.default)(fetch);
function createRetry(url, httpMethod) {
    return function retryOn(attempt, error, response) {
        var _a;
        // Retry up to 3 times on any network error. Do not retry if the server
        // actually sent a valid response back (i.e. status code 500)
        if (attempt < 3 && (error !== null || response === null)) {
            Log.info("HttpClient fetch attempt failed", {
                originalException: error,
                tags: {
                    "api.endpoint": url,
                    "api.method": httpMethod,
                    attempt: attempt + 1,
                    reason: (_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : "unknown",
                },
            });
            // try again
            return true;
        }
        // stop now
        return false;
    };
}
class FetchRetry {
    fetchRetry(url, requestDetails) {
        return __awaiter(this, void 0, void 0, function* () {
            const httpMethod = (requestDetails === null || requestDetails === void 0 ? void 0 : requestDetails.method) || "Unknown";
            const urlDescription = "urlLogDescription" in url ? url.urlLogDescription : url.url;
            return fetchRetry(url.url, Object.assign(Object.assign({}, requestDetails), { retryDelay: 1000, retryOn: createRetry(urlDescription, httpMethod) }));
        });
    }
}
const retry = new FetchRetry();
exports.default = retry;
//# sourceMappingURL=FetchRetry.js.map